/**
 * 이상한 방 - 보간·구간 자르기
 *
 * `clamp01`이 넷(`render/revealHighlight` `render/transition` `game/reveal` `game/sessionWarp`),
 * `smoothstep`이 셋(`render/revealHighlight` `input/isoCamera` `game/reveal`) 있었다. 전부 한
 * 줄짜리라 "복사가 더 싸다"가 맞아 보였지만, 한 줄이라는 것은 **갈라져도 눈에 안 띈다**는 뜻이기도
 * 하다. 실제로 갈렸다 - `transition.ts`의 `clamp01`만 NaN을 0으로 접고 있었고(아래 참조),
 * 나머지 셋은 NaN을 그대로 흘렸다.
 *
 * ## 왜 `core/`인가
 *
 * 쓰는 쪽이 `render/` · `input/` · `game/` 셋으로 갈려 있다. 이 셋이 함께 볼 수 있는 층은
 * `core/`뿐이다(`ui/`에 두면 `render/`가 위를 참조하게 된다). 그래서 여기다.
 *
 * ## NaN은 여기서 처리하지 않는다
 *
 * `clamp01(NaN)`은 `NaN`이다. 비교 두 번이 모두 거짓이라 값이 그대로 나가는 것이고,
 * 그것이 네 사본 중 셋의 동작이었다. NaN 방어가 필요한 곳은 그 사실을 아는 자리에서
 * 감싼다 - `render/transition.ts`의 `clampProgress`가 그 예이고, 거기 주석에 이유가 있다.
 * 여기서 삼켜 버리면 "0이 나왔는데 입력이 NaN이었다"를 어디서도 볼 수 없게 된다.
 */

/** 0~1 구간으로 자른다. 진척도(경과/전체)를 그리기 전에 거는 마지막 관문이다. */
export function clamp01(value: number): number {
  return value < 0 ? 0 : value > 1 ? 1 : value
}

/**
 * smoothstep. 시작·끝의 속도가 0이라 스냅처럼 보이지 않으면서도 상수 하나 없이 끝난다.
 *
 * `t`가 0~1 밖이면 결과도 0~1 밖으로 나간다. 부르기 전에 `clamp01`을 거치는 것이 이 저장소의
 * 관례이고, 실제 호출부(카메라 회전·리빌 접근·글로우 스냅)는 모두 그렇게 하고 있다.
 */
export function smoothstep(t: number): number {
  return t * t * (3 - 2 * t)
}
